import { w as o } from "./addOns-5IZhcbHD.js";
const e = {
  id: "PuertoRicoPega2",
  logo: !0,
  name: "Pega 2",
  style: {
    colorPrimary: "#f06627",
    wildball: o
  }
};
export {
  e as default
};
